import { AtsExportPreset } from "constants/ats-exports";

const presetValues = Object.values(AtsExportPreset);

export const makeCreateAtsExportRequestPayload = (templatePresetOrId: AtsExportPreset | string) => {
    if (presetValues.includes(templatePresetOrId as AtsExportPreset)) {
        const file_type = templatePresetOrId === AtsExportPreset.AtsReportCsv ? "csv" : "xlsx";
        const include_images = templatePresetOrId === AtsExportPreset.AtsReportXlsxWithImages;
        return {
            file_type,
            include_images,
        };
    } else {
        return {
            ats_export_format_id: templatePresetOrId,
        };
    }
};
